<template>
<div class="chapter">
<div class="inner_page">
<div id="toc" style="font-weight:bold">
<h1 id="toc-title">The Satin Moth</h1>
<ol class="toc">
<li id="toc-li-1"><a href="#/text/ch001#about-the-author">About the Author</a></li>
<li id="toc-li-2"><a href="#/text/ch002#dedication">Dedication</a></li>
<li id="toc-li-3"><a href="#/text/ch003#copyright-information">Copyright Information ©</a></li>
<li id="toc-li-4"><a href="#/text/ch004#foreword">Foreword</a></li>
<li id="toc-li-5"><a href="#/text/ch005#chapter-one-the-motherless-girl">Chapter One: The Motherless Girl</a>
</li>
<li id="toc-li-6"><a href="#/text/ch006#chapter-two-favourite-cousins">Chapter Two: Favourite Cousins</a></li>
<li id="toc-li-7"><a href="#/text/ch007#chapter-three-the-white-moth-appears">Chapter Three: The White Moth
          Appears</a></li>
<li id="toc-li-8"><a href="#/text/ch008#chapter-four-laughter-turns-to-tears">Chapter Four: Laughter Turns to
          Tears</a></li>
<li id="toc-li-9"><a href="#/text/ch009#chapter-five-the-night-vigil">Chapter Five: The Night Vigil</a></li>
<li id="toc-li-10"><span href="#/text/ch010#chapter-six-ashes-to-ashes" title="Link target outside of Sample">Chapter Six: Ashes to Ashes</span></li>
<li id="toc-li-11"><span href="#/text/ch011#chapter-seven-the-power-of-the-witch-doctor" title="Link target outside of Sample">
          
          Chapter Seven: The Power of the Witch Doctor</span></li>
<li id="toc-li-12"><span href="#/text/ch012#chapter-eight-a-storm-at-sea" title="Link target outside of Sample">Chapter Eight: A Storm at Sea</span></li>
<li id="toc-li-13"><span href="#/text/ch013#chapter-nine-shanghai-tricks" title="Link target outside of Sample">Chapter Nine: Shanghai Tricks</span></li>
<li id="toc-li-14"><span href="#/text/ch014#chapter-ten-treachery-unveiled" title="Link target outside of Sample">Chapter Ten: Treachery Unveiled</span>
</li>
<li id="toc-li-15"><span href="#/text/ch015#chapter-eleven-the-dawn-raid" title="Link target outside of Sample">Chapter Eleven: The Dawn Raid</span></li>
<li id="toc-li-16"><span href="#/text/ch016#chapter-twelve-king-nazzor-eze" title="Link target outside of Sample">Chapter Twelve: King Nazzor Eze</span>
</li>
<li id="toc-li-17"><span href="#/text/ch017#chapter-thirteen-taken-into-bondage" title="Link target outside of Sample">Chapter Thirteen: Taken into
          Bondage</span></li>
<li id="toc-li-18"><span href="#/text/ch018#chapter-fourteen-leaving-african-soil-forever" title="Link target outside of Sample">Chapter Fourteen:
          Leaving African Soil Forever</span></li>
<li id="toc-li-19"><span href="#/text/ch019#chapter-fifteen-shipwreck" title="Link target outside of Sample">Chapter Fifteen: Shipwreck</span></li>
<li id="toc-li-20"><span href="#/text/ch020#chapter-sixteen-nabilas-curse" title="Link target outside of Sample">Chapter Sixteen: Nabila’s Curse</span>
</li>
<li id="toc-li-21"><span href="#/text/ch021#chapter-seventeen-a-glimpse-of-the-future" title="Link target outside of Sample">Chapter Seventeen: A
          Glimpse of the Future</span></li>
<li id="toc-li-22"><span href="#/text/ch022#chapter-eighteen-the-loneliest-christmas" title="Link target outside of Sample">Chapter Eighteen: The
          Loneliest Christmas</span></li>
<li id="toc-li-23"><span href="#/text/ch023#chapter-nineteen-out-of-the-saddle" title="Link target outside of Sample">Chapter Nineteen: Out of the
          Saddle</span></li>
<li id="toc-li-24"><span href="#/text/ch024#chapter-twenty-warriors-foal" title="Link target outside of Sample">Chapter Twenty: Warrior’s Foal</span></li>
<li id="toc-li-25"><span href="#/text/ch025#chapter-twenty-one-the-birthday-girl" title="Link target outside of Sample">Chapter Twenty-One: The Birthday
          Girl</span></li>
<li id="toc-li-26"><span href="#/text/ch026#chapter-twenty-two-visit-to-the-museum" title="Link target outside of Sample">Chapter Twenty-Two: Visit to
          the Museum</span></li>
<li id="toc-li-27"><span href="#/text/ch027#chapter-twenty-three-the-roman-holiday" title="Link target outside of Sample">Chapter Twenty-Three: The
          Roman Holiday</span></li>
<li id="toc-li-28"><span href="#/text/ch028#chapter-twenty-four-the-minister-of-deliverance" title="Link target outside of Sample">Chapter Twenty-Four:
          The Minister of Deliverance</span></li>
<li id="toc-li-29"><span href="#/text/ch029#chapter-twenty-five-family-history" title="Link target outside of Sample">Chapter Twenty-Five: Family
          History</span></li>
<li id="toc-li-30"><span href="#/text/ch030#chapter-twenty-six-the-lichen-stones" title="Link target outside of Sample">Chapter Twenty-Six: The Lichen
          Stones</span></li>
<li id="toc-li-31"><span href="#/text/ch031#chapter-twenty-seven-finding-the-doll" title="Link target outside of Sample">Chapter Twenty-Seven: Finding
          the Doll</span></li>
<li id="toc-li-32"><span href="#/text/ch032#chapter-twenty-eight-the-dreams-start" title="Link target outside of Sample">Chapter Twenty-Eight: The
          Dreams Start</span></li>
<li id="toc-li-33"><span href="#/text/ch033#chapter-twenty-nine-trapped-in-a-storm" title="Link target outside of Sample">Chapter Twenty-Nine: Trapped
          in a Storm</span></li>
<li id="toc-li-34"><span href="#/text/ch034#chapter-thirty-the-boating-accident" title="Link target outside of Sample">Chapter Thirty: The Boating
          Accident</span></li>
<li id="toc-li-35"><span href="#/text/ch035#chapter-thirty-one-the-nightmare" title="Link target outside of Sample">Chapter Thirty-One: The
          Nightmare</span></li>
<li id="toc-li-36"><span href="#/text/ch036#chapter-thirty-two-the-generals-secret-is-revealed" title="Link target outside of Sample">Chapter
          Thirty-Two: The General’s Secret Is Revealed</span></li>
<li id="toc-li-37"><span href="#/text/ch037#chapter-thirty-three-the-labyrinth" title="Link target outside of Sample">Chapter Thirty-Three: The
          Labyrinth</span></li>
<li id="toc-li-38"><span href="#/text/ch038#chapter-thirty-four-christmas-eve" title="Link target outside of Sample">Chapter Thirty-Four: Christmas
          Eve</span></li>
<li id="toc-li-39"><span href="#/text/ch039#chapter-thirty-five-idema" title="Link target outside of Sample">Chapter Thirty-Five: Idema</span></li>
<li id="toc-li-40"><span href="#/text/ch040#chapter-thirty-six-a-bright-and-beautiful-dawn" title="Link target outside of Sample">Chapter Thirty-Six: A
          Bright and Beautiful Dawn</span></li>
<li id="toc-li-41"><span href="#/text/ch041#epilogue" title="Link target outside of Sample">Epilogue</span></li>
</ol>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// nav.vue?04ddaa40